
// State Object for TracksCatalog. Dont directly mutate it anywhere except the tracks/mutations.js file
export const tracksCatalogState = {
  tracksCatalogData: null,
  trackList: null,
  trackDetails: null,
  track_list_start_from: 0,
    
  searchConfig: {},
}


